import * as Sentry from "@sentry/react";

import { ENV } from "./env";

const SENTRY_IGNORED_ERRORS = [
  // Injected by browser extensions (e.g. LastPass, Grammarly) trying to call back
  // into DOM nodes that no longer exist after a React re-render — not app code.
  /Object Not Found Matching Id/,
  // Chrome extension messaging API (chrome.runtime.sendMessage) — never called by this app.
  /Invalid call to runtime\.sendMessage/,
  // iOS WKWebView native bridge (in-app browsers) failing to ack a postMessage after
  // the host app backgrounds/suspends the WebView — not something this app calls.
  /WKWebView API client did not respond to this postMessage/,
  // Android WebView JS-to-Java bridge (addJavascriptInterface) used by injected
  // autofill/form-scanning scripts (scanForForms) — not a function this app defines.
  /Java bridge method invocation error/,
  // SignalR's own transport layer throws this synchronously when the server cancels
  // an in-flight handshake (flaky client network) — thrown deep inside the library's
  // raw onreceive callback, outside any promise chain our code controls.
  /Server returned handshake error: Handshake was canceled/,
];

// Start error reporting, skipping noise the app cannot fix.
export const initializeSentry = () => {
  Sentry.init({
    dsn: ENV.SENTRY_DSN,
    ignoreErrors: SENTRY_IGNORED_ERRORS,
  });
};
